//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The filter applied to the GetCommunicationConversation query */
export const CommunicationMessageFilter = {
    /** When this option is selected, only messages that have actual replies (and with IsRead=false) are considered */
    ShowUnreadReplies: 0,

    /** When this option is selected, it would show messages that have any replies/responses (IsRead true or false) */
    ShowAllReplies: 1,

    /** When this option is selected, all messages are shown regardless of any replies/responses. */
    ShowAllMessages: 2
} as const;

/** The filter applied to the GetCommunicationConversation query */
export const CommunicationMessageFilterDescription: Record<number, string> = {
    0: "Show Unread Replies",

    1: "Show All Replies",

    2: "Show All Messages"
};

/** The filter applied to the GetCommunicationConversation query */
export type CommunicationMessageFilter = typeof CommunicationMessageFilter[keyof typeof CommunicationMessageFilter];
